import React, {Fragment} from "react"
import UserEvent from "../../core/UserEvent"
import IconButton from "@material-ui/core/IconButton"
import {Box, Icon, Popover} from "@material-ui/core"
import {makeStyles} from "@material-ui/core/styles"
import i18n from "../../core/i18n";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: '0px',
        padding: '0',
    },
    label: {
        padding: '0.3em',
        borderRadius: '0px',
    }
}))

function SymbolToolButton(props) {
    const {value, icon, style = {}, onClick, 'aria-label': ariaLabel} = props
    const symbols = ['°', '℃', '℉', '±', '‰', 'α', 'β', 'γ', 'δ', 'µ', '㎡', '㏒', 'Φ', 'Ø', '/', '~', '≦',  '≧', '＜', '＞', '{', '}', '→', '↓', '←', '↑', '※', '@', '#', '『', '』', '【', '】', '、']
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = React.useState(null)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleChange = event => {
        const {value} = event
        event.preventDefault()
        onClick && onClick(new UserEvent({value}, event))
    }

    const open = Boolean(anchorEl)
    const symbolButtons = symbols.map(symbol => <SymbolButton value={symbol} key={symbol} onClick={handleChange} />)
    const title = i18n.translate(props.title)

    return (
        <Fragment>
            <IconButton value={value} classes={classes} style={style} onClick={handleClick}
                        title={title} aria-label={i18n.translate(ariaLabel) || title} >
                <Icon fontSize="small" >{icon}</Icon>
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Box padding={1}>
                    <Box maxWidth="16rem">
                        {symbolButtons}
                    </Box>
                </Box>
            </Popover>
        </Fragment>
    )
}


const useSymbolButtonStyles = makeStyles(theme => ({
    root: {
        width: '2em',
        height: '2em',
        cursor: 'pointer',
    }
}))
function SymbolButton({value, onClick}) {
    const classes = useSymbolButtonStyles()
    const handleClick = (event) => {
        event.preventDefault()
        onClick && onClick(new UserEvent({value}, event))
    }
    // 不可以使用 IconButton，在某些情況會導致 RichText 重複 render，selection 的位置改變到該列的開始的位置。
    return (
        <Box onClick={handleClick} classes={classes} display="inline-flex" justifyContent="center" alignItems="center">
            <span>{value}</span>
        </Box>
    )
}

SymbolToolButton.propTypes = {
    value: PropTypes.string,
    icon: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    title: PropTypes.string,
    'aria-label': PropTypes.string,
}

export default SymbolToolButton